// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function useParseMarket(country, currency, language) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var isAnimus = Caml_obj.equal(match.config.accountId, "nVCcJkO2M") && Caml_obj.equal(country, "DE");
  return [isAnimus ? undefined : country, isAnimus ? undefined : currency, isAnimus ? undefined : language];
}
export { useParseMarket };
/* ConfigurationProvider-Showside Not a pure module */